<template>
  <form @submit.prevent="submit">
    <FormGroup small-label :error="fieldHasErrors('name')" required>
      <template #label>
        <i class="iconoir-text"></i>
        {{ $t('workspaceForm.nameLabel') }}
      </template>

      <FormInput
        ref="name"
        v-model="v$.values.name.$model"
        :error="fieldHasErrors('name')"
        size="large"
        @focus.once="$event.target.select()"
        @blur="v$.values.name.$touch"
      ></FormInput>

      <template #error>{{ $t('error.requiredField') }}</template>
    </FormGroup>

    <FormGroup small-label>
      <template #label>
        <i class="iconoir-image"></i>
        Logo
      </template>

      <div style="display: flex; align-items: center; gap: 12px;">
        <Avatar
          v-if="values.logo"
          :image="values.logo.url"
          rounded
        ></Avatar>
        <Button
          type="button"
          size="small"
          icon="iconoir-upload"
          @click="$refs.userFilesModal.show('file')"
        >
          {{ values.logo ? 'Mudar Logo' : 'Upload Logo' }}
        </Button>
        <Button
          v-if="values.logo"
          type="button"
          size="small"
          icon="iconoir-trash"
          @click="values.logo = null"
        >
          Remover
        </Button>
      </div>

      <UserFilesModal
        ref="userFilesModal"
        :multiple-files="false"
        :file-types-acceptable="['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml']"
        @uploaded="onLogoUploaded"
      ></UserFilesModal>
    </FormGroup>

    <slot></slot>
  </form>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'

import form from '@baserow/modules/core/mixins/form'
import UserFilesModal from '@baserow/modules/core/components/files/UserFilesModal.vue'

export default {
  name: 'WorkspaceForm',
  components: { UserFilesModal },
  mixins: [form],
  props: {
    defaultName: {
      type: String,
      required: false,
      default: '',
    },
    defaultLogo: {
      type: Object,
      required: false,
      default: null,
    },
  },
  setup() {
    return { v$: useVuelidate({ $lazy: true }) }
  },
  data() {
    return {
      values: {
        name: this.defaultName,
        logo: this.defaultLogo,
      },
    }
  },
  validations() {
    return {
      values: {
        name: {
          required: helpers.withMessage(
            this.$t('error.requiredField'),
            required
          ),
        },
      },
    }
  },

  async mounted() {
    this.$refs.name.focus()
  },
  methods: {
    onLogoUploaded(files) {
      if (files && files.length > 0) {
        this.values.logo = files[0]
      }
      this.$refs.userFilesModal.hide()
    },
  },
}
</script>
